'use client';

import { useCallback } from 'react';
import type { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { useLocalizedPageUrlDispatch } from '../../providers/LocalizedPageUrlProvider/useLocalizedPageUrl';
import { usePageTransitionNavigate } from '../../providers/PageTransitionProvider/usePageTransition';

export function useRouterPush() {
  const setUrl = useLocalizedPageUrlDispatch();
  const navigate = usePageTransitionNavigate();

  const push = useCallback(
    (href: string, options?: NavigateOptions) => {
      setUrl(href);
      navigate(href, options);
    },
    [navigate, setUrl],
  );

  return push;
}
